import { Avatar, Box, Stack, Typography } from "@mui/material";
import Button from "@mui/material/Button/Button";
import Container from "@mui/material/Container/Container";
import Link from "@mui/material/Link/Link";
import { THEME, TonConnectButton, useTonConnectUI } from "@tonconnect/ui-react";
import { useEffect } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { useDaoJettonData } from "../libs/daoService";

const DaoLogo = () => {
  const { data } = useDaoJettonData();
  if (!data) {
    return <div></div>;
  } else {
    return (
      <Stack
        direction="row"
        spacing={2}
        justifyContent="center"
        alignItems="center"
      >
        <Avatar alt="Logo" src={data.image} />
        <Typography
          variant="subtitle2"
          component="h2"
          sx={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            maxWidth: "250px",
            textOverflow: "ellipsis",
          }}
        >
          {data.name}
        </Typography>
      </Stack>
    );
  }
};

export const Header = () => {
  const navigate = useNavigate();

  const [, setOptions] = useTonConnectUI();
  useEffect(() => {
    setOptions({ uiPreferences: { theme: THEME.LIGHT } });
  }, [setOptions]);

  return (
    <Box
      component="header"
      sx={{
        py: 2,
        height: "73px",
        borderBottom: "1px solid",
        borderColor: (theme) => theme.palette.grey[100],
      }}
    >
      <Container
        maxWidth="sm"
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Routes>
          <Route path=":address/*" element={<DaoLogo />} />
          <Route
            path="deploy"
            element={
              <Button size="large" onClick={() => navigate("/")}>
                Back
              </Button>
            }
          />
          <Route
            index
            element={
              <Button
                variant="contained"
                size="large"
                onClick={() => navigate("/deploy")}
              >
                Create new DAO
              </Button>
            }
          />
        </Routes>

        <TonConnectButton />
      </Container>
    </Box>
  );
};

function Copyright() {
  return (
    <Typography variant="body2" color="text.secondary">
      {"Ton Console © "}
      <Link color="inherit" href="/">
        DAO Manager
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

export const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        pt: 3,
        pb: 4,
        mt: "auto",
        borderTop: "1px solid",
        borderColor: (theme) => theme.palette.grey[100],
      }}
    >
      <Container maxWidth="sm">
        <Copyright />
      </Container>
    </Box>
  );
};
